/* Billows Loyalty — complete reward first, then open the final cart drawer */
(function () {
  'use strict';

  var CLAIM_URL =
    'https://mefbsgubwgyuybclaldl.supabase.co/functions/v1/loyalty-cart-claim';

  var RELEASE_URL =
    'https://mefbsgubwgyuybclaldl.supabase.co/functions/v1/loyalty-release-reward';

  var DATA_QUERY_KEY =
    'billows_reward_data';

  var LEGACY_QUERY_KEY =
    'billows_rewards';

  var TOKEN_PROPERTY =
    '_billows_redemption_token';

  var PENDING_HANDOFF_KEY =
    'billows_pending_reward_handoff_v9';

  var RELEASE_QUEUE_KEY =
    'billows_loyalty_release_candidates_v7';

  var releaseFlushRunning =
    false;

  var releaseTimers = [];

  var decorateTimer =
    null;

  var handoffProcessing =
    false;

  function root() {
    var value =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return value.endsWith('/')
      ? value
      : value + '/';
  }

  function unique(values) {
    return Array.from(
      new Set(
        (values || [])
          .map(function (value) {
            return String(
              value || '',
            ).trim();
          })
          .filter(Boolean),
      ),
    );
  }

  function normalizeDiscountMode(
    item,
  ) {
    var explicitMode =
      String(
        item.discount_mode ||
          item.discountMode ||
          '',
      )
        .trim()
        .toLowerCase();

    if (
      explicitMode === 'code' ||
      explicitMode === 'automatic'
    ) {
      return explicitMode;
    }

    var discountCode =
      String(
        item.discount_code ||
          item.discountCode ||
          '',
      ).trim();

    if (discountCode) {
      return 'code';
    }

    var automaticDiscountId =
      String(
        item.automatic_discount_id ||
          item.automaticDiscountId ||
          '',
      ).trim();

    if (automaticDiscountId) {
      return 'automatic';
    }

    return '';
  }

  function normalizeHandoffItem(
    item,
  ) {
    if (
      !item ||
      typeof item !== 'object'
    ) {
      return null;
    }

    var token =
      String(
        item.redemption_token ||
          item.redemptionToken ||
          '',
      ).trim();

    var variantId =
      Number(
        item.variant_id ||
          item.variantId ||
          0,
      );

    var rewardKey =
      String(
        item.reward_key ||
          item.rewardKey ||
          '',
      ).trim();

    var pointsSpent =
      Number(
        item.points_spent ||
          item.pointsSpent ||
          0,
      );

    var discountMode =
      normalizeDiscountMode(
        item,
      );

    var discountCode =
      String(
        item.discount_code ||
          item.discountCode ||
          '',
      ).trim();

    var automaticDiscountId =
      String(
        item.automatic_discount_id ||
          item.automaticDiscountId ||
          '',
      ).trim();

    var automaticDiscountTitle =
      String(
        item.automatic_discount_title ||
          item.automaticDiscountTitle ||
          'Billows Loyalty Reward',
      ).trim();

    if (
      !token ||
      !Number.isFinite(
        variantId,
      ) ||
      variantId <= 0 ||
      ![
        'code',
        'automatic',
      ].includes(
        discountMode,
      )
    ) {
      return null;
    }

    if (
      discountMode === 'code' &&
      !discountCode
    ) {
      return null;
    }

    if (
      discountMode === 'automatic' &&
      !automaticDiscountId
    ) {
      return null;
    }

    return {
      redemption_token:
        token,

      variant_id:
        variantId,

      reward_key:
        rewardKey,

      points_spent:
        Number.isFinite(
          pointsSpent,
        )
          ? pointsSpent
          : 0,

      discount_mode:
        discountMode,

      discount_code:
        discountCode,

      automatic_discount_id:
        automaticDiscountId,

      automatic_discount_title:
        automaticDiscountTitle,
    };
  }

  function normalizeHandoffItems(
    items,
  ) {
    if (
      !Array.isArray(
        items,
      )
    ) {
      return [];
    }

    var seen =
      new Set();

    return items
      .map(
        normalizeHandoffItem,
      )
      .filter(
        function (item) {
          if (
            !item ||
            seen.has(
              item.redemption_token,
            )
          ) {
            return false;
          }

          seen.add(
            item.redemption_token,
          );

          return true;
        },
      )
      .slice(
        0,
        10,
      );
  }

  function parseDataFromUrl() {
    var url =
      new URL(
        window.location.href,
      );

    var raw =
      url.searchParams.get(
        DATA_QUERY_KEY,
      );

    if (!raw) {
      return [];
    }

    try {
      return normalizeHandoffItems(
        JSON.parse(raw),
      );
    } catch (error) {
      console.error(
        'Billows loyalty: invalid handoff payload',
        error,
      );

      return [];
    }
  }

  function parseLegacyTokensFromUrl() {
    var url =
      new URL(
        window.location.href,
      );

    var raw =
      url.searchParams.get(
        LEGACY_QUERY_KEY,
      );

    return raw
      ? unique(
          String(raw).split(
            ',',
          ),
        ).slice(
          0,
          10,
        )
      : [];
  }

  function cleanAddressBar() {
    var url =
      new URL(
        window.location.href,
      );

    var changed =
      false;

    [
      DATA_QUERY_KEY,
      LEGACY_QUERY_KEY,
    ].forEach(
      function (key) {
        if (
          url.searchParams.has(
            key,
          )
        ) {
          url.searchParams.delete(
            key,
          );

          changed =
            true;
        }
      },
    );

    if (!changed) {
      return;
    }

    window.history.replaceState(
      {},
      '',
      url.pathname +
        (
          url.searchParams.toString()
            ? '?' +
              url.searchParams.toString()
            : ''
        ) +
        url.hash,
    );
  }

  function savePendingHandoff(
    payload,
  ) {
    try {
      window.sessionStorage.setItem(
        PENDING_HANDOFF_KEY,
        JSON.stringify(
          payload,
        ),
      );

      return true;
    } catch (error) {
      console.error(
        'Billows loyalty: could not save pending handoff',
        error,
      );

      return false;
    }
  }

  function readPendingHandoff() {
    try {
      var value =
        JSON.parse(
          window.sessionStorage.getItem(
            PENDING_HANDOFF_KEY,
          ) || 'null',
        );

      if (
        !value ||
        typeof value !==
          'object'
      ) {
        return null;
      }

      return {
        items:
          normalizeHandoffItems(
            value.items,
          ),

        tokens:
          unique(
            value.tokens || [],
          ).slice(
            0,
            10,
          ),
      };
    } catch (error) {
      console.error(
        'Billows loyalty: invalid saved handoff',
        error,
      );

      return null;
    }
  }

  function clearPendingHandoff() {
    try {
      window.sessionStorage.removeItem(
        PENDING_HANDOFF_KEY,
      );
    } catch (error) {
      console.error(
        'Billows loyalty: could not clear pending handoff',
        error,
      );
    }
  }

  function ensureLoyaltyStyles() {
    if (
      document.getElementById(
        'billows-loyalty-cart-style',
      )
    ) {
      return;
    }

    var style =
      document.createElement(
        'style',
      );

    style.id =
      'billows-loyalty-cart-style';

    style.textContent =
      '.billows-loyalty-line .cart-item__details>.product-option,' +
      '.billows-loyalty-line .cart-item__details>.cart-item__discounted-prices,' +
      '.billows-loyalty-line .cart-item__details>dl,' +
      '.billows-loyalty-line .cart-item__details>.discounts,' +
      '.billows-loyalty-line .cart-item__totals s,' +
      '.billows-loyalty-line .cart-item__totals .cart-item__old-price,' +
      '.billows-loyalty-line .discounts{' +
      'display:none!important' +
      '}' +

      '.billows-loyalty-line .cart-item__name{' +
      'font-weight:950!important' +
      '}' +

      '.billows-loyalty-subtitle{' +
      'display:block;' +
      'margin-top:5px;' +
      'color:#6b6258;' +
      'font-size:12px;' +
      'font-weight:850;' +
      'line-height:1.35' +
      '}' +

      '.billows-loyalty-line .cart-item__quantity quantity-input{' +
      'pointer-events:none' +
      '}' +

      '#billows-loyalty-error-toast{' +
      'position:fixed;' +
      'left:50%;' +
      'bottom:92px;' +
      'transform:translateX(-50%);' +
      'z-index:2147483647;' +
      'display:none;' +
      'width:calc(100% - 32px);' +
      'max-width:420px;' +
      'padding:13px 16px;' +
      'border-radius:14px;' +
      'background:#9f1717;' +
      'color:#fff;' +
      'font:800 14px/1.5 inherit;' +
      'text-align:center;' +
      'box-shadow:0 12px 30px rgba(0,0,0,.24)' +
      '}';

    document.head.appendChild(
      style,
    );
  }

  function ensureErrorToast() {
    ensureLoyaltyStyles();

    var existing =
      document.getElementById(
        'billows-loyalty-error-toast',
      );

    if (existing) {
      return existing;
    }

    var toast =
      document.createElement(
        'div',
      );

    toast.id =
      'billows-loyalty-error-toast';

    toast.setAttribute(
      'role',
      'alert',
    );

    toast.setAttribute(
      'aria-live',
      'assertive',
    );

    document.body.appendChild(
      toast,
    );

    return toast;
  }

  function showError(message) {
    var toast =
      ensureErrorToast();

    toast.textContent =
      message;

    toast.style.display =
      'block';

    window.clearTimeout(
      toast._billowsHideTimer,
    );

    toast._billowsHideTimer =
      window.setTimeout(
        function () {
          toast.style.display =
            'none';
        },
        6500,
      );
  }

  function decorateLoyaltyLines() {
    ensureLoyaltyStyles();

    var heading =
      document.querySelector(
        'cart-drawer .drawer__heading',
      );

    if (heading) {
      heading.textContent =
        'طلبك';
    }

    document
      .querySelectorAll(
        'button[data-billows-loyalty-reward="true"]',
      )
      .forEach(
        function (button) {
          var row =
            button.closest(
              'tr.cart-item',
            );

          if (!row) {
            return;
          }

          row.classList.add(
            'billows-loyalty-line',
          );

          row
            .querySelectorAll(
              '.discounts, ' +
                '.cart-item__details dl, ' +
                '.cart-item__details .product-option, ' +
                '.cart-item__details .cart-item__discounted-prices',
            )
            .forEach(
              function (
                element,
              ) {
                element.style.display =
                  'none';
              },
            );

          var title =
            row.querySelector(
              '.cart-item__name',
            );

          if (!title) {
            return;
          }

          var cleanTitle =
            title.textContent
              .replace(
                /\s*-\s*Loyalty Reward\s*$/i,
                '',
              )
              .trim();

          if (
            title.textContent.trim() !==
            cleanTitle
          ) {
            title.textContent =
              cleanTitle;
          }

          if (
            !row.querySelector(
              '.billows-loyalty-subtitle',
            )
          ) {
            var subtitle =
              document.createElement(
                'span',
              );

            subtitle.className =
              'billows-loyalty-subtitle';

            subtitle.textContent =
              'هدية من نقاطك';

            title.insertAdjacentElement(
              'afterend',
              subtitle,
            );
          }
        },
      );
  }

  function scheduleDecoration() {
    window.clearTimeout(
      decorateTimer,
    );

    decorateTimer =
      window.setTimeout(
        decorateLoyaltyLines,
        0,
      );
  }

  function observeCartDrawer() {
    var drawer =
      document.querySelector(
        'cart-drawer',
      );

    if (
      !drawer ||
      drawer
        ._billowsObserverAttached
    ) {
      return;
    }

    drawer
      ._billowsObserverAttached =
      true;

    new MutationObserver(
      function () {
        scheduleDecoration();
      },
    ).observe(
      drawer,
      {
        childList:
          true,

        subtree:
          true,
      },
    );
  }

  async function responseJson(
    response,
  ) {
    var text =
      await response.text();

    try {
      return text
        ? JSON.parse(
            text,
          )
        : {};
    } catch (error) {
      throw new Error(
        'Invalid JSON response (HTTP ' +
          response.status +
          ')',
      );
    }
  }

  async function request(
    url,
    options,
  ) {
    var response =
      await fetch(
        url,
        options,
      );

    var data =
      await responseJson(
        response,
      );

    if (
      !response.ok ||
      data.ok === false
    ) {
      var error =
        new Error(
          data.message ||
            data.description ||
            data.error ||
            'Request failed',
        );

      error.status =
        response.status;

      error.payload =
        data;

      throw error;
    }

    return data;
  }

  function claim(
    action,
    tokens,
    keepalive,
  ) {
    return request(
      CLAIM_URL,
      {
        method:
          'POST',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify({
            action:
              action,

            tokens:
              tokens,
          }),

        keepalive:
          Boolean(
            keepalive,
          ),
      },
    );
  }

  function releaseReward(
    token,
    keepalive,
    releaseSource,
  ) {
    return request(
      RELEASE_URL,
      {
        method:
          'POST',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify({
            redemption_token:
              token,

            release_source:
              releaseSource ||
              'cart_remove',
          }),

        keepalive:
          Boolean(
            keepalive,
          ),
      },
    );
  }

  function isTerminalReleaseError(
    error,
  ) {
    var code =
      String(
        error &&
        error.payload &&
        error.payload.error ||
        '',
      );

    return [
      'reward_linked_to_order',
      'completed_redemption_cannot_be_released',
      'redemption_status_not_releasable',
      'redemption_not_found',
    ].includes(
      code,
    );
  }

  function isUnavailableRewardError(
    error,
  ) {
    var code =
      String(
        error &&
        error.payload &&
        error.payload.error ||
        '',
      );

    return [
      'redemption_expired',
      'redemption_unavailable',
      'redemption_not_found',
    ].includes(
      code,
    );
  }

  function getCart() {
    return request(
      root() +
        'cart.js',
      {
        method:
          'GET',

        headers: {
          Accept:
            'application/json',
        },

        credentials:
          'same-origin',

        cache:
          'no-store',
      },
    );
  }

  function lineToken(item) {
    return String(
      (
        item.properties ||
        {}
      )[TOKEN_PROPERTY] ||
        '',
    ).trim();
  }

  function tokensInCart(cart) {
    var values =
      new Set();

    (
      cart.items ||
      []
    ).forEach(
      function (item) {
        var token =
          lineToken(
            item,
          );

        if (token) {
          values.add(
            token,
          );
        }
      },
    );

    return values;
  }

  function activeDiscountCodes(
    cart,
  ) {
    return (
      cart.discount_codes ||
      []
    )
      .filter(
        function (
          discount,
        ) {
          return (
            discount &&
            discount.code &&
            discount.applicable !==
              false
          );
        },
      )
      .map(
        function (
          discount,
        ) {
          return String(
            discount.code,
          ).trim();
        },
      )
      .filter(Boolean);
  }

  function missingCartItems(
    items,
    existingTokens,
  ) {
    return items
      .filter(
        function (item) {
          return !existingTokens.has(
            item
              .redemption_token,
          );
        },
      )
      .map(
        function (item) {
          return {
            id:
              Number(
                item
                  .variant_id,
              ),

            quantity:
              1,

            properties: {
              _billows_redemption_token:
                item
                  .redemption_token,

              _billows_reward_key:
                item
                  .reward_key ||
                '',

              _billows_points_spent:
                String(
                  item
                    .points_spent ||
                    '',
                ),
            },
          };
        },
      );
  }

  async function addItems(
    items,
  ) {
    if (!items.length) {
      return;
    }

    var response =
      await fetch(
        root() +
          'cart/add.js',
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          credentials:
            'same-origin',

          body:
            JSON.stringify({
              items:
                items,
            }),
        },
      );

    var data =
      await responseJson(
        response,
      );

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          'تعذر إضافة المكافأة للسلة',
      );
    }
  }

  async function applyDiscountCodes(
    codes,
  ) {
    var cleanCodes =
      unique(
        codes,
      );

    if (!cleanCodes.length) {
      throw new Error(
        'لم يتم العثور على خصم المكافأة',
      );
    }

    var response =
      await fetch(
        root() +
          'cart/update.js',
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          credentials:
            'same-origin',

          body:
            JSON.stringify({
              discount:
                cleanCodes.join(
                  ',',
                ),

              sections: [
                'cart-drawer',
                'cart-icon-bubble',
              ],

              sections_url:
                window.location.pathname,
            }),
        },
      );

    var data =
      await responseJson(
        response,
      );

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          'تعذر تطبيق خصم المكافأة',
      );
    }

    return data;
  }

  async function removeLine(
    lineKey,
  ) {
    var response =
      await fetch(
        root() +
          'cart/change.js',
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          credentials:
            'same-origin',

          body:
            JSON.stringify({
              id:
                lineKey,

              quantity:
                0,
            }),
        },
      );

    var data =
      await responseJson(
        response,
      );

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          'تعذر حذف المكافأة',
      );
    }
  }

  async function legacyPrepare(
    tokens,
  ) {
    var result =
      await claim(
        'prepare',
        tokens,
        false,
      );

    return normalizeHandoffItems(
      result.items ||
        [],
    );
  }

  async function confirmWithRetry(
    tokens,
  ) {
    var delays =
      [0, 350, 900];

    var lastError =
      null;

    for (
      var delay of delays
    ) {
      if (delay > 0) {
        await new Promise(
          function (resolve) {
            window.setTimeout(
              resolve,
              delay,
            );
          },
        );
      }

      try {
        return await claim(
          'confirm',
          tokens,
          true,
        );
      } catch (error) {
        lastError =
          error;
      }
    }

    throw lastError ||
      new Error(
        'cart_confirmation_failed',
      );
  }

  function findCartItemByToken(
    cart,
    token,
  ) {
    return (
      cart.items ||
      []
    ).find(
      function (item) {
        return (
          lineToken(
            item,
          ) === token
        );
      },
    );
  }

  function itemIsFree(
    item,
  ) {
    if (!item) {
      return false;
    }

    return (
      Number(
        item.final_line_price,
      ) === 0 ||
      (
        Number(
          item.quantity ||
            0,
        ) === 1 &&
        Number(
          item.final_price,
        ) === 0
      )
    );
  }

  function assertRewardPricing(
    cart,
    tokens,
  ) {
    var allItemsExist =
      tokens.every(
        function (token) {
          return Boolean(
            findCartItemByToken(
              cart,
              token,
            ),
          );
        },
      );

    var allItemsAreFree =
      tokens.every(
        function (token) {
          return itemIsFree(
            findCartItemByToken(
              cart,
              token,
            ),
          );
        },
      );

    if (
      !allItemsExist ||
      !allItemsAreFree
    ) {
      throw new Error(
        'reward_discount_not_applied',
      );
    }
  }

  function replaceElementFromSection(
    sectionHtml,
    selector,
  ) {
    if (!sectionHtml) {
      return false;
    }

    var parsed =
      new DOMParser()
        .parseFromString(
          sectionHtml,
          'text/html',
        );

    var source =
      parsed.querySelector(
        selector,
      );

    var current =
      document.querySelector(
        selector,
      );

    if (
      !source ||
      !current
    ) {
      return false;
    }

    current.replaceWith(
      document.importNode(
        source,
        true,
      ),
    );

    return true;
  }

  async function fetchFreshSections() {
    var separator =
      window.location.search
        ? '&'
        : '?';

    var url =
      window.location.pathname +
      window.location.search +
      separator +
      'sections=cart-drawer,cart-icon-bubble';

    var response =
      await fetch(
        url,
        {
          method:
            'GET',

          headers: {
            Accept:
              'application/json',
          },

          credentials:
            'same-origin',

          cache:
            'no-store',
        },
      );

    var data =
      await responseJson(
        response,
      );

    if (
      !response.ok ||
      typeof data[
        'cart-drawer'
      ] !==
        'string'
    ) {
      throw new Error(
        'تعذر تحديث محتوى سلة الطلب',
      );
    }

    return data;
  }

  async function renderCartAndOpen(
    cartData,
  ) {
    var sections =
      cartData.sections ||
      null;

    if (
      !sections ||
      typeof sections[
        'cart-drawer'
      ] !==
        'string'
    ) {
      sections =
        await fetchFreshSections();
    }

    replaceElementFromSection(
      sections[
        'cart-icon-bubble'
      ],
      '#cart-icon-bubble',
    );

    var drawerReplaced =
      replaceElementFromSection(
        sections[
          'cart-drawer'
        ],
        'cart-drawer',
      );

    if (!drawerReplaced) {
      throw new Error(
        'تعذر عرض محتوى سلة الطلب',
      );
    }

    window.requestAnimationFrame(
      function () {
        observeCartDrawer();
        decorateLoyaltyLines();

        window.setTimeout(
          function () {
            var drawer =
              document.querySelector(
                'cart-drawer',
              );

            if (
              drawer &&
              typeof drawer.open ===
                'function'
            ) {
              drawer.open();

              return;
            }

            var trigger =
              document.querySelector(
                '#cart-icon-bubble',
              );

            if (trigger) {
              trigger.click();
            }
          },
          20,
        );
      },
    );
  }

  async function rollbackRewardTokens(
    tokens,
  ) {
    var cleanTokens =
      unique(
        tokens || [],
      );

    if (!cleanTokens.length) {
      return {
        released: true,
      };
    }

    try {
      var cart =
        await getCart();

      for (
        var cartItem of
        cart.items ||
        []
      ) {
        if (
          cleanTokens.includes(
            lineToken(
              cartItem,
            ),
          ) &&
          cartItem.key
        ) {
          try {
            await removeLine(
              cartItem.key,
            );
          } catch (error) {
            console.error(
              'Billows loyalty: cart rollback line failed',
              error,
            );
          }
        }
      }
    } catch (error) {
      console.error(
        'Billows loyalty: cart rollback lookup failed',
        error,
      );
    }

    var released =
      true;

    for (
      var token of
      cleanTokens
    ) {
      try {
        await releaseReward(
          token,
          false,
          'handoff_failed',
        );
      } catch (error) {
        if (
          isTerminalReleaseError(
            error,
          )
        ) {
          continue;
        }

        released =
          false;

        console.error(
          'Billows loyalty: points rollback failed',
          error,
        );

        queueRewardRelease(
          token,
        );
      }
    }

    return {
      released:
        released,
    };
  }

  async function cleanupStaleRewardLines() {
    try {
      var cart =
        await getCart();

      var tokenToKeys =
        new Map();

      for (
        var cartItem of
        cart.items || []
      ) {
        var token =
          lineToken(
            cartItem,
          );

        if (
          !token ||
          !cartItem.key
        ) {
          continue;
        }

        if (
          !tokenToKeys.has(
            token,
          )
        ) {
          tokenToKeys.set(
            token,
            [],
          );
        }

        tokenToKeys
          .get(token)
          .push(
            cartItem.key,
          );
      }

      if (!tokenToKeys.size) {
        return;
      }

      var removedAny =
        false;

      for (
        var entry of
        tokenToKeys.entries()
      ) {
        var rewardToken =
          entry[0];

        var lineKeys =
          entry[1];

        try {
          await claim(
            'prepare',
            [rewardToken],
            false,
          );
        } catch (error) {
          if (
            !isUnavailableRewardError(
              error,
            )
          ) {
            console.error(
              'Billows loyalty: reward cart validation failed',
              error,
            );

            continue;
          }

          for (
            var lineKey of
            lineKeys
          ) {
            try {
              await removeLine(
                lineKey,
              );

              removedAny =
                true;
            } catch (removeError) {
              console.error(
                'Billows loyalty: stale reward line removal failed',
                removeError,
              );
            }
          }
        }
      }

      if (removedAny) {
        try {
          var sections =
            await fetchFreshSections();

          replaceElementFromSection(
            sections[
              'cart-icon-bubble'
            ],
            '#cart-icon-bubble',
          );

          replaceElementFromSection(
            sections[
              'cart-drawer'
            ],
            'cart-drawer',
          );

          observeCartDrawer();
          decorateLoyaltyLines();
        } catch (renderError) {
          console.error(
            'Billows loyalty: stale reward cart refresh failed',
            renderError,
          );
        }
      }
    } catch (error) {
      console.error(
        'Billows loyalty: stale reward cleanup failed',
        error,
      );
    }
  }

  async function processHandoff(
    savedHandoff,
  ) {
    if (
      !savedHandoff ||
      handoffProcessing
    ) {
      return;
    }

    handoffProcessing =
      true;

    var items =
      savedHandoff.items ||
      [];

    var tokens =
      unique(
        (
          savedHandoff.tokens ||
          []
        ).concat(
          items.map(
            function (item) {
              return item
                .redemption_token;
            },
          ),
        ),
      );

    try {
      var currentCart;

      if (
        !items.length &&
        tokens.length
      ) {
        var results =
          await Promise.all([
            getCart(),
            legacyPrepare(
              tokens,
            ),
          ]);

        currentCart =
          results[0];

        items =
          results[1];

        tokens =
          unique(
            items.map(
              function (item) {
                return item
                  .redemption_token;
              },
            ),
          );
      } else {
        currentCart =
          await getCart();
      }

      if (
        !items.length ||
        !tokens.length
      ) {
        throw new Error(
          'لا توجد مكافأة جاهزة للإضافة',
        );
      }

      var tokensPresentBefore =
        tokensInCart(
          currentCart,
        );

      await addItems(
        missingCartItems(
          items,
          tokensPresentBefore,
        ),
      );

      var codeItems =
        items.filter(
          function (item) {
            return (
              item
                .discount_mode ===
              'code'
            );
          },
        );

      var cartAfterDiscount;

      if (
        codeItems.length
      ) {
        cartAfterDiscount =
          await applyDiscountCodes(
            activeDiscountCodes(
              currentCart,
            ).concat(
              codeItems.map(
                function (item) {
                  return item
                    .discount_code;
                },
              ),
            ),
          );
      } else {
        cartAfterDiscount =
          await getCart();
      }

      assertRewardPricing(
        cartAfterDiscount,
        tokens,
      );

      /*
       * The reward is now physically present in the cart and its
       * final price has been verified as zero. Do not block the
       * customer on Supabase bookkeeping before showing the cart.
       */
      clearPendingHandoff();
      cleanAddressBar();

      try {
        await renderCartAndOpen(
          cartAfterDiscount,
        );
      } catch (renderError) {
        console.error(
          'Billows loyalty: reward added but cart drawer render failed',
          renderError,
        );

        showError(
          'تمت إضافة المكافأة بنجاح. افتح سلة الطلب لمراجعتها.',
        );
      }

      /*
       * Confirm added_to_cart after the drawer is visible.
       * The order webhook can safely link both pending and
       * added_to_cart redemptions, so this is not allowed to
       * delay the customer's cart experience.
       */
      confirmWithRetry(
        tokens,
      ).catch(
        function (confirmError) {
          console.error(
            'Billows loyalty: background cart confirmation failed',
            confirmError,
          );
        },
      );
    } catch (error) {
      console.error(
        'Billows loyalty cart handoff failed:',
        error,
      );

      var rollback =
        await rollbackRewardTokens(
          tokens,
        );

      clearPendingHandoff();

      showError(
        rollback.released
          ? 'حصلت مشكلة أثناء إضافة المكافأة وتم إرجاع نقاطها. حاول مرة تانية من صفحة المكافآت.'
          : 'حصلت مشكلة أثناء إضافة المكافأة. تم حفظ طلب إرجاع النقاط وسيتم استكماله تلقائيًا.',
      );
    } finally {
      handoffProcessing =
        false;
    }
  }

  function readReleaseQueue() {
    try {
      var value =
        JSON.parse(
          window.localStorage.getItem(
            RELEASE_QUEUE_KEY,
          ) || '[]',
        );

      return unique(
        Array.isArray(
          value,
        )
          ? value
          : [],
      ).slice(
        0,
        30,
      );
    } catch (error) {
      console.error(
        'Billows loyalty: invalid release queue',
        error,
      );

      return [];
    }
  }

  function writeReleaseQueue(
    tokens,
  ) {
    try {
      var cleanTokens =
        unique(
          tokens,
        ).slice(
          0,
          30,
        );

      if (
        cleanTokens.length
      ) {
        window.localStorage.setItem(
          RELEASE_QUEUE_KEY,
          JSON.stringify(
            cleanTokens,
          ),
        );
      } else {
        window.localStorage.removeItem(
          RELEASE_QUEUE_KEY,
        );
      }
    } catch (error) {
      console.error(
        'Billows loyalty: could not save release queue',
        error,
      );
    }
  }

  function queueRewardRelease(
    token,
  ) {
    token =
      String(
        token ||
          '',
      ).trim();

    if (!token) {
      return;
    }

    writeReleaseQueue(
      readReleaseQueue().concat(
        token,
      ),
    );
  }

  function scheduleReleaseFlush() {
    releaseTimers.forEach(
      function (timer) {
        window.clearTimeout(
          timer,
        );
      },
    );

    releaseTimers =
      [
        250,
        900,
        2200,
      ].map(
        function (delay) {
          return window.setTimeout(
            flushReleaseQueue,
            delay,
          );
        },
      );
  }

  async function flushReleaseQueue() {
    if (
      releaseFlushRunning
    ) {
      return;
    }

    var candidates =
      readReleaseQueue();

    if (
      !candidates.length
    ) {
      return;
    }

    releaseFlushRunning =
      true;

    try {
      var cart =
        await getCart();

      var currentTokens =
        tokensInCart(
          cart,
        );

      var remaining =
        [];

      for (
        var token of
        candidates
      ) {
        if (
          currentTokens.has(
            token,
          )
        ) {
          remaining.push(
            token,
          );

          continue;
        }

        try {
          await releaseReward(
            token,
            true,
          );
        } catch (error) {
          if (
            !isTerminalReleaseError(
              error,
            )
          ) {
            remaining.push(
              token,
            );
          }

          console.error(
            'Billows loyalty: background reward release failed',
            error,
          );
        }
      }

      writeReleaseQueue(
        remaining,
      );

      if (
        remaining.length
      ) {
        window.setTimeout(
          flushReleaseQueue,
          2500,
        );
      }
    } catch (error) {
      console.error(
        'Billows loyalty: release queue cart check failed',
        error,
      );

      window.setTimeout(
        flushReleaseQueue,
        2500,
      );
    } finally {
      releaseFlushRunning =
        false;
    }
  }

  function handleRewardRemove(
    event,
  ) {
    if (
      !(
        event.target instanceof
        Element
      )
    ) {
      return;
    }

    var button =
      event.target.closest(
        'button[data-billows-loyalty-reward="true"]',
      );

    if (!button) {
      return;
    }

    var token =
      String(
        button.getAttribute(
          'data-billows-redemption-token',
        ) || '',
      ).trim();

    if (!token) {
      return;
    }

    /*
     * حذف السطر يتم فورًا بواسطة الكارت.
     * حذف الخصم وإرجاع النقاط يتمان في الخلفية.
     */
    queueRewardRelease(
      token,
    );

    scheduleReleaseFlush();
  }

  function clearOldRuntimeKeys() {
    [
      'billows_pending_reward_handoff_v3',
      'billows_pending_reward_handoff_v4',
      'billows_pending_reward_handoff_v5',
      'billows_pending_reward_handoff_v6',
      'billows_pending_reward_handoff_v7',
      'billows_pending_reward_handoff_v8',

      'billows_rewards_processing_v3',
      'billows_rewards_processing_v4',
      'billows_rewards_processing_v5',
      'billows_rewards_processing_v6',
      'billows_rewards_processing_v7',
      'billows_rewards_processing_v8',
      'billows_rewards_processing_v9',

      'billows_open_cart_after_loyalty_reload_v3',
      'billows_open_cart_after_reload',
    ].forEach(
      function (key) {
        window.sessionStorage.removeItem(
          key,
        );
      },
    );
  }

  function start() {
    ensureLoyaltyStyles();
    observeCartDrawer();
    decorateLoyaltyLines();
    flushReleaseQueue();
    clearOldRuntimeKeys();

    var dataItems =
      parseDataFromUrl();

    var legacyTokens =
      parseLegacyTokensFromUrl();

    var urlHandoff =
      null;

    if (
      dataItems.length ||
      legacyTokens.length
    ) {
      urlHandoff = {
        items:
          dataItems,

        tokens:
          legacyTokens,
      };

      if (
        savePendingHandoff(
          urlHandoff,
        )
      ) {
        cleanAddressBar();
      }
    }

    var pending =
      readPendingHandoff() ||
      urlHandoff;

    var hasActiveHandoff =
      Boolean(
        pending &&
        (
          pending
            .items
            .length ||
          pending
            .tokens
            .length
        )
      );

    if (
      !hasActiveHandoff
    ) {
      cleanupStaleRewardLines();

      return;
    }

    /*
     * During an active reward handoff, stale-cart cleanup must not
     * compete with the critical add + discount + verify path.
     * Run it only after the handoff has finished, so it cannot
     * delay the drawer from opening.
     */
    processHandoff(
      pending,
    ).finally(
      function () {
        window.setTimeout(
          cleanupStaleRewardLines,
          1200,
        );
      },
    );
  }

  document.addEventListener(
    'click',
    handleRewardRemove,
    true,
  );

  window.addEventListener(
    'online',
    flushReleaseQueue,
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once:
          true,
      },
    );
  } else {
    start();
  }
})();